import { Basic } from "../basic";
import { markStore , MarkStore, marksData } from "@lib/store/src/mark";
import { MarkModal } from "./modals/mark-modal";
import { restoreImagesFromStore , setupDragAndDrop } from "./utils/image-tools";
import { showMarkControlContextMenu } from "./utils/context-menu-mark";
import styles from "./modals/mark-modals.styles.css";
import { setupClickOutsideHandler } from "./utils/event-handlers";
import { reaction } from "mobx";
import i18next from "i18next";

export class MSMarkControl extends Basic {
  private static _modal: MarkModal | null = null;

  static get observedAttributes() {
    return super.observedAttributes.concat(["connectionlinecolor","selectionoutlinecolor","marksdata", "marks", "x", "y", "fontsize"]);
  }

  constructor() {
    super();
    this._restoredOnce = false;
  }
  _connectionlinecolor: string = "#216aff";
  _selectionoutlinecolor: string = "#216aff";
  _restoreOnce: boolean;
  _marksdata: any;
  _marks: any;
  _posters: any;
  markStores: any;
  _hasParam: boolean;
  disposer: any;
  _restoredOnce: boolean;
  _x: any;
  _y: any;
  _fontsize: any;
  
  get x() {
    return this._x;
  }

  set x(value) {
    this._x = value
    this.style.left = this._x;
  }

  get y() {
    return this._y;
  }

  set y(value) {
    this._y = value;
    this.style.top = this._y;
  }

  get fontsize() {
    return this._fontsize;
  }

  set fontsize(value) {
    this._fontsize = value;
    this.style.fontSize = this._fontsize;;
  }

  get marksdata () {
    return this._marksdata;
  }
  
  set marksdata(value) {
    const data = value?.value ?? value;
    if (!data?.marksData) return;
    const myData = data.marksData.find(s=> s.id === this.id);
    if (!myData) return;
    const myStore = marksData.marksData.find(s => s.id === this.id);
    if (!myStore) return;
    myStore.hydrateFromJSON(myData);
    
    if (!this._restoredOnce) {
      setTimeout(() => {
        restoreImagesFromStore(this);
      }, 0);
      this._restoredOnce = true;
    } else {
    }
  }

  get connectionlinecolor() {
    return this._connectionlinecolor;
  }


  set connectionlinecolor(value: string) {
    this._connectionlinecolor = value;
  }

  get selectionoutlinecolor() {
    return this._selectionoutlinecolor;
  }

  set selectionoutlinecolor(value: string) {
    this._selectionoutlinecolor = value;
  }

  connectedCallback() {
    super.connectedCallback?.();
    const styleTag = document.createElement("style");
    styleTag.textContent = styles;
    document.head.appendChild(styleTag);
    this.style.position = "absolute";
    this.style.display = "inline-flex";
    this.style.alignItems = "center";
    this.style.justifyContent = "center";

    const label = document.createElement("span");
    label.textContent = `${i18next.t("marks")}`
    this.appendChild(label);
    this.addEventListener("contextmenu", this._contextMenuHandler);

    this.markStores = new MarkStore();
    this.markStores.id = this.getAttribute("id");
    marksData.marksData.push(this.markStores)
    this.onStoreChange()

    this.markStores.connectionlinecolor = this._connectionlinecolor;
    this.markStores.selectionoutlinecolor = this._selectionoutlinecolor;

    setupClickOutsideHandler();
    if(!this._hasParam) {
      restoreImagesFromStore(this);
      this._hasParam = true;
    }
    this.setupClickHandler();
    setupDragAndDrop(this);

  }

  private _contextMenuHandler = (e: MouseEvent) => {
    e.preventDefault();
    const id = this.getAttribute("id");
    document.querySelectorAll(".ms-markcontrol").forEach(c => c.classList.remove("opened"));
    this.classList.add("opened");
    if (id) showMarkControlContextMenu(e, id);
  }

  private setupClickHandler() {
    const marksAttr = this.getAttribute("marks");
    const postersAttr = this.getAttribute("posters");
    const notesAttr = this.getAttribute("notes");
    let posters: any[] = [];
    let notes: any[] = [];

    if (marksAttr) {
      const parsed = JSON.parse(marksAttr);
      posters = Array.isArray(parsed.mark) ? parsed.mark : [parsed.mark];
    } else if (postersAttr) {
      const postersParsed = JSON.parse(postersAttr);
      posters = Array.isArray(postersParsed.mark) ? postersParsed.mark : [postersParsed.mark];

      if (notesAttr) {
        const notesParsed = JSON.parse(notesAttr);
        notes = Array.isArray(notesParsed.mark) ? notesParsed.mark : [notesParsed.mark];
      }
    }
    
    this.classList.add("ms-markcontrol");
    const isMark = marksAttr;
    this.textContent = isMark ? `${i18next.t("marks")}` : `${i18next.t("posters")}`;
    if(marksAttr == null && postersAttr == null) this.textContent = `${i18next.t("marks")}`;
    
    this.onclick = () => {
      if (!MSMarkControl._modal) {
        MSMarkControl._modal = new MarkModal("mark-popup");
        MSMarkControl._modal.initObserver();
      }
      markStore.isMarkControl = this.textContent === `${i18next.t("marks")}`;
      document.querySelectorAll(".ms-markcontrol").forEach(c => c.classList.remove("opened"));
      this.classList.add("opened");
      markStore.openModal(posters, notes); 
    };
  }

  onStoreChange() {
    this.disposer = reaction(
      () => JSON.stringify(this.markStores.toJSON()),
      () => {
        this.SetParameter("marksdata", marksData, null, null, null, null , null);
      }
    );
  }
  
  disconnectedCallback(): void {
    this.removeEventListener("contextmenu" , this._contextMenuHandler);
  }
}


